import React, { Suspense, useContext } from 'react'
import { TicketShowWithParams } from '../pages/Ticket/TicketShow'
import { SlideInDrawer } from './SlideInDrawer'
import styled from 'styled-components'
import { ExternalTicketShowWithParams } from '../pages/ExternalTicket/ExternalTicketShow'
import SessionContext from '../SessionContext'

interface Props {
  slug: string
  open: boolean
  onClose: () => void
}

const ShowTicket = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
`

const LiveRequestDrawer: React.FC<Props> = ({ slug, open, onClose }) => {
  const { user } = useContext(SessionContext)
  return (
    <SlideInDrawer size='default' anchor='right' open={open} elevation={0} onClose={onClose}>
      <ShowTicket>
        {user?.contact?.contactType === 'internal' && (
          <Suspense fallback={<>Loading...</>}>
            <TicketShowWithParams slug={slug} renderContext='drawer' />
          </Suspense>
        )}
        {user?.contact?.contactType === 'external' && (
          <Suspense fallback={<>Loading...</>}>
            <ExternalTicketShowWithParams slug={slug} renderContext='drawer' />
          </Suspense>
        )}
      </ShowTicket>
    </SlideInDrawer>
  )
}

export default LiveRequestDrawer
